export default "__VITE_ASSET__vTd9UV8d__"